import React, { PropTypes } from 'react';
import shallowEqual from 'react-pure-render/shallowEqual';

const IGNORE_CLASS = 'ignore-react-onclickoutside';

function isSourceFound(source, localNode) {
  if (source === localNode) {
    return true;
  }
  // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
  if (source.correspondingElement) {
    return source.correspondingElement.classList.contains(IGNORE_CLASS);
  }
  return source.classList.contains(IGNORE_CLASS);
}

// Higher order component to trigger a callback when user clicks outside of the
// component
export default function createOnClickOutside(Component) {
  class OnClickOutside extends React.Component {
    constructor(props) {
      super(props);
      this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
      let source = event.target;
      let found = false;
      // If source=local then this event came from "somewhere"
      // inside and should be ignored. We could handle this with
      // a layered approach, too, but that requires going back to
      // thinking in terms of Dom node nesting, running counter
      // to React's "you shouldn't care about the DOM" philosophy.
      // Credit: react-onclickoutside
      while (source.parentNode) {
        found = isSourceFound(source, this._localNode);
        if (found) {
          return;
        }
        source = source.parentNode;
      }
      this.props.onRequestClose(event);
    }

    shouldComponentUpdate(nextProps) {
      return !shallowEqual(this.props, nextProps);
    }

    componentDidMount() {
      // add event listeners
      document.addEventListener("click", this.handleClick);

      this._localNode = React.findDOMNode(this);
    }

    componentWillUnmount() {
      // remove event listeners
      document.removeEventListener("click", this.handleClick);
    }

    render() {
      return <Component {...this.props } />;
    }
  }

  OnClickOutside.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
  };

  OnClickOutside.defaultProps = {
    onRequestClose: () => {},
  };

  return OnClickOutside;
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/createOnClickOutside.jsx
 **/